import React, { useEffect } from 'react';

/**
 * Centralised logout endpoint for the portal.
 *
 * Used by the portal itself AND by sub-apps (RFQ, invoice-checker, ...)
 * which redirect their users here on logout so a single click ends every
 * session at once.
 *
 * Strategy: clear portal's auth localStorage *and then hard-reload* to
 * `/`. The hard reload is intentional — it guarantees the AuthProvider
 * re-runs its bootstrap with no token rather than racing against
 * `<Navigate>` while the previous in-memory token still re-authenticates
 * the user back into `/modules`.
 */
const LogoutPage: React.FC = () => {
  useEffect(() => {
    try {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
    } catch {
      /* localStorage may be unavailable (private mode); reload still helps */
    }
    window.location.replace('/');
  }, []);

  return (
    <div className="loading-container">
      <div className="spinner" />
      <p>Signing out…</p>
    </div>
  );
};

export default LogoutPage;
